import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpg'
import { FaAward } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { GoProjectSymlink } from "react-icons/go";



const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about_container'>
        <div className="about_me">
          <div className="about_me-image">
            <img src={ME} alt="Portrait of Ismam Fatin Zishan" />
          </div>

        </div>

        <div className="about_content">
          <div className="about_cards">
            <article className='about_card'>
            <FaAward className='about_icon'/>
              <h5>Experience</h5>
              <small>4+ Year Working</small>
            </article>

            <article className='about_card'>
            <FaUsers className='about_icon' />
              <h5>Clients</h5>
              <small>20+ Clients Worldwide</small>
            </article>

            <article className='about_card'>
            <GoProjectSymlink className='about_icon'/>
              <h5>Projects</h5>
              <small>28+ Completed Projects</small>
            </article>
          </div>
          <div className='about_text'>
            <p>
              I have a diverse background in technical account management and software development, bringing both product and engineering
              perspectives to every project. I have onboarded e-commerce merchants, integrated their data, and communicated complex issues
              clearly to both business and technical stakeholders.
            </p>
            <p>
              My foundation is a B.Sc. in Computer Science (Multimedia major) from University Putra Malaysia, and I am currently pursuing
              an M.Sc. in Information Technology at RMIT. I work across React, Node.js, Django, SQL, Python, and cloud-focused systems,
              with hands-on experience in testing, performance tuning, and delivery.
            </p>
            <p>
              I enjoy building practical products, from machine-learning-based apps to full-stack platforms, and I am always open to
              collaborations where strong engineering and user impact matter.
            </p>
          </div>

          <a href='#contact'className='btn btn-primary'>Let's Connect</a>
        </div>
      </div>
      </section>
  )
}

export default About